import { Link } from "react-router-dom";
import { ArrowLeft, Download } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const CaseNav = ({ index, total }) => {
  return (
    <nav
      data-no-print="true"
      data-testid="case-nav"
      className="fixed top-0 left-0 right-0 z-50 bg-[var(--paper)]/85 backdrop-blur-md hairline-b border-b"
    >
      <div className="max-w-[1480px] mx-auto px-5 md:px-10 flex items-center justify-between h-14 md:h-16">
        <Link
          to="/#campaigns"
          data-testid="case-nav-back"
          className="inline-flex items-center gap-2 text-[11px] tracking-[0.2em] uppercase font-medium hover:opacity-60 transition-opacity"
        >
          <ArrowLeft className="w-3.5 h-3.5" strokeWidth={1.5} />
          <span className="hidden sm:inline">Back to all work</span>
          <span className="sm:hidden">Back</span>
        </Link>

        <div className="text-[11px] tracking-[0.22em] uppercase font-medium opacity-60 hidden md:block">
          Case Study №{String(index + 1).padStart(2, "0")} /{" "}
          {String(total).padStart(2, "0")}
        </div>

        <a
          href={`${BACKEND_URL}/api/resume/download`}
          data-testid="case-nav-resume"
          className="inline-flex items-center gap-2 bg-[var(--ink)] text-[var(--paper)] px-4 md:px-5 py-2.5 text-[10.5px] md:text-[11px] tracking-[0.2em] uppercase font-medium hover:bg-[var(--paper)] hover:text-[var(--ink)] border border-[var(--ink)] transition-colors"
        >
          <Download className="w-3.5 h-3.5" strokeWidth={1.75} />
          Resume
        </a>
      </div>
    </nav>
  );
};
